/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import {
  SkeletonCircle,
  SkeletonRow,
  SkeletonText,
} from 'src/components/ts-components/SkeletonBlock'

/** Mirrors the panel's own shape so nothing shifts when data lands. */
const PanelSkeleton = () => (
  <div css={wrapperStyle} data-testid='panel-skeleton'>
    <div css={headerStyle}>
      <SkeletonCircle size={52} />
      <div css={titlesStyle}>
        <SkeletonText width={220} height={20} />
        <SkeletonText width={160} height={12} />
      </div>
    </div>
    <div css={statsStyle}>
      {[0, 1, 2, 3].map((index) => (
        <SkeletonText key={index} width={70} height={30} />
      ))}
    </div>
    {[0, 1, 2, 3, 4].map((index) => (
      <SkeletonRow key={index} height={40} />
    ))}
  </div>
)

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
`

const headerStyle = css`
  display: flex;
  align-items: center;
  gap: 14px;
`

const titlesStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const statsStyle = css`
  display: flex;
  gap: 20px;
  margin-bottom: 6px;
`

export default PanelSkeleton
